/* LUS Homepage v2 — behaviour.
   The page is many independent Shopify sections, so this file must survive any
   section being absent, reordered, or re-rendered by the theme editor.
   Everything is null-safe and idempotent: each element is bound at most once
   (data-lus-* flags) and init() re-runs on shopify:section:load. */
(function () {
  if (window.__lusHome) { window.__lusHome.init(); return; }

  var body = document.body;
  body.dataset.lvl = body.dataset.lvl || '2';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function claim(el, key) {
    if (!el || el.dataset[key]) return false;
    el.dataset[key] = '1';
    return true;
  }

  /* ---------- level switcher ---------- */
  function initSwitcher() {
    document.querySelectorAll('.lvl button').forEach(function (b) {
      if (!claim(b, 'lusSw')) return;
      b.addEventListener('click', function () {
        document.querySelectorAll('.lvl button').forEach(function (x) { x.classList.remove('on'); });
        b.classList.add('on');
        body.dataset.lvl = b.dataset.set;
      });
    });
  }

  /* ---------- sticky nav + hero parallax (one global scroll listener) ---------- */
  window.addEventListener('scroll', function () {
    var nav = document.getElementById('navbar');
    if (nav) nav.classList.toggle('stuck', window.scrollY > 12);
    if (body.dataset.lvl !== '1' && !reduce && window.scrollY < 700) {
      var y = window.scrollY * 0.22;
      document.querySelectorAll('.hslide.on .hero-media, .hero > .hero-media').forEach(function (m) {
        m.style.transform = 'translateY(' + y + 'px)';
      });
    }
  }, { passive: true });

  /* ---------- hero slider ----------
     The dots live in .hero-edge, a sibling of <section class="hero"> — the
     capsule has to straddle the boundary line, and the hero clips its overflow
     to keep the video inside the frame. So look for them in the shared parent.

     This is the ONLY hero timer. assets/lus-hero-auto.js used to run a second
     one that advanced the banner by clicking the dots; two schedulers on one
     slider skipped and double-stepped, which is what "it doesn't always want
     to move on" looked like. That file is now inert and no longer loaded. */
  function initHero() {
    document.querySelectorAll('.lus-hero').forEach(function (hero) {
      if (!claim(hero, 'lusHero')) return;

      var scope = hero.parentNode || document;
      var slides = [].slice.call(hero.querySelectorAll('.hslide'));
      if (!slides.length) return;

      var vids = function (s) { return [].slice.call(s.querySelectorAll('video')); };
      var load = function (s) {
        vids(s).forEach(function (v) {
          if (!v.getAttribute('src') && v.dataset.src && getComputedStyle(v).display !== 'none') { v.src = v.dataset.src; v.load(); }
        });
      };
      var play = function (s) {
        load(s);
        vids(s).forEach(function (v) {
          if (getComputedStyle(v).display !== 'none') { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        });
      };
      var pause = function (s) { vids(s).forEach(function (v) { v.pause(); }); };

      play(slides[0]);
      if (slides.length < 2) return;

      var dots = [].slice.call(scope.querySelectorAll('.hdot'));
      var capsule = scope.querySelector('.hero-nav');
      var auto = hero.dataset.autoplay === 'true' && !reduce;
      /* Seconds come from the section setting, which also drives --slide-dur,
         so the indicator fills over exactly the time left on the banner. */
      var wait = parseInt(hero.dataset.interval, 10) || 5000;
      var i = 0, timer = null;

      function restart() {
        clearInterval(timer);
        if (auto && !document.hidden) timer = setInterval(function () { go(i + 1); }, wait);
      }

      function go(n) {
        n = (n % slides.length + slides.length) % slides.length;
        if (n === i) { restart(); return; }
        slides[i].classList.remove('on');
        slides[i].setAttribute('aria-hidden', 'true');
        slides[i].querySelectorAll('a').forEach(function (a) { a.tabIndex = -1; });
        pause(slides[i]);

        i = n;
        slides[i].classList.add('on');
        slides[i].removeAttribute('aria-hidden');
        slides[i].querySelectorAll('a').forEach(function (a) { a.removeAttribute('tabindex'); });
        play(slides[i]);

        dots.forEach(function (d, k) {
          d.classList.toggle('on', k === i);
          d.setAttribute('aria-selected', k === i ? 'true' : 'false');
        });

        /* the capsule gives a short squeeze so the change is felt, not just seen */
        if (capsule && !reduce) {
          capsule.classList.remove('pulse');
          void capsule.offsetWidth;
          capsule.classList.add('pulse');
        }

        /* fetch the next one so the swap is never a black frame */
        load(slides[(i + 1) % slides.length]);
        restart();
      }

      dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });

      /* Hover pause covers the copy card and the indicator only. It used to be
         bound to the whole hero, so a pointer resting anywhere over the
         artwork — most of the screen when the page opens — stopped the
         rotation until the mouse moved away. */
      [].slice.call(scope.querySelectorAll('.hero-in, .hero-nav')).forEach(function (z) {
        z.addEventListener('mouseenter', function () { clearInterval(timer); });
        z.addEventListener('mouseleave', restart);
      });
      hero.addEventListener('focusin', function () { clearInterval(timer); });
      hero.addEventListener('focusout', restart);
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) { clearInterval(timer); } else { restart(); }
      });
      hero.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(i + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(i - 1); }
      });

      var x0 = null;
      hero.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      hero.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 50) go(dx < 0 ? i + 1 : i - 1);
        x0 = null;
      }, { passive: true });

      load(slides[1]);
      restart();
    });
  }

  /* ---------- mega menu (desktop) ---------- */
  function initMega() {
    var nav = document.getElementById('navbar');
    var shop = document.getElementById('shopBtn');
    var mega = document.getElementById('mega');
    if (!nav || !shop || !mega || !claim(nav, 'lusMega')) return;

    var closeT;
    var stagger = function () {
      mega.querySelectorAll('.mi').forEach(function (el, k) {
        el.style.transitionDelay = (body.dataset.lvl === '1' ? 0 : k * 0.035) + 's';
      });
    };
    var open = function () { clearTimeout(closeT); nav.classList.add('open'); shop.setAttribute('aria-expanded', 'true'); stagger(); };
    var close = function () { closeT = setTimeout(function () { nav.classList.remove('open'); shop.setAttribute('aria-expanded', 'false'); }, 160); };

    shop.addEventListener('mouseenter', open);
    shop.addEventListener('click', function () {
      var isOpen = nav.classList.toggle('open');
      shop.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      stagger();
    });
    shop.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); shop.click(); }
    });
    nav.addEventListener('mouseleave', close);
    mega.addEventListener('mouseenter', function () { clearTimeout(closeT); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { nav.classList.remove('open'); shop.setAttribute('aria-expanded', 'false'); }
    });
  }

  /* ---------- burger + mobile drawer ---------- */
  function initBurger() {
    var nav = document.getElementById('navbar');
    var burger = document.getElementById('burgerBtn');
    var drawer = document.getElementById('drawer');
    if (!nav || !burger || !drawer || !claim(burger, 'lusBurger')) return;

    var set = function (open) {
      nav.classList.toggle('drawer-open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      burger.innerHTML = open ? '<i class="ti ti-x"></i>' : '<i class="ti ti-menu-2"></i>';
    };
    burger.addEventListener('click', function () { set(!nav.classList.contains('drawer-open')); });
    drawer.addEventListener('click', function (e) { if (e.target.closest('a')) set(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') set(false); });
    window.addEventListener('resize', function () { if (window.innerWidth > 600) set(false); });
  }

  /* ---------- add to cart, without leaving the page ---------- */
  function cartCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = !n; });
  }
  function initCart() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      if (!claim(form, 'lusCart')) return;
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return;
        e.preventDefault();
        var btn = form.querySelector('button[type=submit]');
        var label = btn ? btn.textContent : '';
        if (btn) { btn.disabled = true; btn.textContent = '…'; }
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: form.querySelector('[name=id]').value, quantity: 1 }) })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); return fetch('/cart.js'); })
          .then(function (r) { return r.json(); })
          .then(function (c) { cartCount(c.item_count); if (btn) btn.textContent = btn.dataset.added || 'Added'; })
          .catch(function () { if (btn) btn.textContent = 'Try again'; })
          .then(function () { setTimeout(function () { if (btn) { btn.disabled = false; btn.textContent = label; } }, 1600); });
      });
    });
  }

  /* ---------- reveal on scroll ---------- */
  var rio = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); rio.unobserve(e.target); } });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
  function initReveal() {
    document.querySelectorAll('.rv').forEach(function (el) { if (claim(el, 'lusRv')) rio.observe(el); });
  }

  /* ---------- counters ---------- */
  function run(el) {
    var to = parseFloat(el.dataset.to) || 0, dec = parseInt(el.dataset.dec || 0), t0 = null, dur = 1500;
    var step = function (ts) {
      if (!t0) t0 = ts;
      var p = Math.min((ts - t0) / dur, 1);
      var v = to * (1 - Math.pow(1 - p, 3));
      el.textContent = dec ? v.toFixed(dec) : Math.floor(v).toLocaleString('en-US');
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = dec ? to.toFixed(dec) : to.toLocaleString('en-US');
    };
    requestAnimationFrame(step);
  }
  var cio = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target;
      if (reduce) {
        var to = parseFloat(el.dataset.to) || 0;
        el.textContent = el.dataset.dec ? to.toFixed(el.dataset.dec) : to.toLocaleString('en-US');
      } else run(el);
      cio.unobserve(el);
    });
  }, { threshold: 0.5 });
  function initCounters() {
    document.querySelectorAll('.cnt').forEach(function (el) { if (claim(el, 'lusCnt')) cio.observe(el); });
  }

  /* ---------- xp bar ---------- */
  var xio = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.style.width = (e.target.dataset.fill || '68') + '%'; xio.unobserve(e.target); } });
  }, { threshold: 0.4 });
  function initXp() {
    document.querySelectorAll('.xpfill').forEach(function (el) { if (claim(el, 'lusXp')) xio.observe(el); });
  }

  /* ---------- product carousel ---------- */
  function initCarousel() {
    document.querySelectorAll('.track').forEach(function (track) {
      if (!claim(track, 'lusTrack')) return;
      var root = track.closest('section') || document;
      var prev = root.querySelector('.arrows .prev');
      var next = root.querySelector('.arrows .next');
      var stepBy = function () { var c = track.querySelector('.pcard'); return c ? c.offsetWidth + 12 : 300; };
      var sync = function () {
        if (prev) prev.disabled = track.scrollLeft < 8;
        if (next) next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 8;
      };
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -stepBy() * 2, behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: stepBy() * 2, behavior: 'smooth' }); });
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();

      var down = false, moved = false, sx = 0, sl = 0;
      track.addEventListener('pointerdown', function (e) { down = true; moved = false; sx = e.clientX; sl = track.scrollLeft; track.style.scrollSnapType = 'none'; });
      window.addEventListener('pointerup', function () { if (down) { down = false; track.style.scrollSnapType = 'x mandatory'; } });
      window.addEventListener('pointermove', function (e) {
        if (!down) return;
        if (Math.abs(e.clientX - sx) > 4) moved = true;
        track.scrollLeft = sl - (e.clientX - sx);
      });
      track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    });
  }

  /* ---------- cursor glow (level 3) ---------- */
  var gx = 0, gy = 0, cx = 0, cy = 0, seen = false;
  window.addEventListener('pointermove', function (e) { gx = e.clientX; gy = e.clientY; seen = true; }, { passive: true });
  (function loop() {
    if (seen && body.dataset.lvl === '3') {
      var glow = document.getElementById('glow');
      if (glow) {
        cx += (gx - cx) * 0.08; cy += (gy - cy) * 0.08;
        glow.style.left = cx + 'px'; glow.style.top = cy + 'px';
      }
    }
    requestAnimationFrame(loop);
  })();

  /* ---------- tilt (level 3) ---------- */
  function initTilt() {
    document.querySelectorAll('.pcard,.rcard').forEach(function (el) {
      if (!claim(el, 'lusTilt')) return;
      el.addEventListener('pointermove', function (e) {
        if (body.dataset.lvl !== '3' || reduce) return;
        var r = el.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5, py = (e.clientY - r.top) / r.height - 0.5;
        el.style.transform = 'translateY(-6px) perspective(700px) rotateX(' + (-py * 5) + 'deg) rotateY(' + (px * 5) + 'deg)';
      });
      el.addEventListener('pointerleave', function () { el.style.transform = ''; });
    });
  }

  function init() {
    initSwitcher(); initHero(); initMega(); initBurger(); initCart();
    initReveal(); initCounters(); initXp(); initCarousel(); initTilt();
  }

  window.__lusHome = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
